import config from '../../../config';

export const fetchRedeemGiftCard = ({ inputCode }) =>
  $.ajax({
      type: 'PUT',
      url: `${config.api}/gift_card/${inputCode}/redemption`,
  });



// WEBPACK FOOTER //
// ./src/Common/Providers/GiftCardApi.js